(function(){'use strict';function ready(fn){if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',fn,{once:true});else fn()}function setHeaderReady(){document.documentElement.classList.remove('js-loading');document.documentElement.classList.add('page-ready')}ready(setHeaderReady);function refreshAccHeights(scope){(scope||document).querySelectorAll('.desc_acc .desc-content').forEach(function(panel){panel.style.removeProperty('display');var h=panel.scrollHeight||0;if(panel.parentElement)panel.parentElement.style.setProperty('--faetton-desc-height',Math.max(h+48,320)+'px')})}ready(function(){refreshAccHeights(document);window.addEventListener('resize',function(){refreshAccHeights(document)},{passive:true})});document.addEventListener('click',function(e){var summary=e.target.closest&&e.target.closest('.desc-summary');if(!summary||!summary.closest('.desc_acc'))return;e.preventDefault();e.stopImmediatePropagation();var parent=summary.closest('.desc_acc');var panel=parent.querySelector('.desc-content');if(panel)panel.style.removeProperty('display');refreshAccHeights(parent);summary.classList.toggle('active');parent.classList.toggle('open')},true);document.addEventListener('click',function(e){var btn=e.target.closest&&e.target.closest('.stiky_btn');if(!btn)return;e.preventDefault();e.stopImmediatePropagation();try{document.body.classList.remove('overflowy-hidden')}catch(err){}document.querySelectorAll('.return_inner').forEach(function(el){el.classList.add('hidden')});document.querySelectorAll('.return-overlay').forEach(function(el){el.classList.add('hidden')});var target=document.querySelector('.main-atc-form button[name="add"],.main-atc-form,form.main_form button[name="add"],form.main_form,.purchase-details__buttons,.purchase-details');if(target){target.scrollIntoView({behavior:'smooth',block:'center'});setTimeout(function(){try{target.focus&&target.focus({preventScroll:true})}catch(err){}},450)}},true);function updateMacArrows(root){(root||document).querySelectorAll('.slide-work .mac-cards').forEach(function(scroller){var wrap=scroller.closest('.mac-cards-wrap')||scroller.closest('.slide-work');var scope=scroller.closest('.slide-work')||document;var prev=scope.querySelector('.mac-slide-arrow.icon-left-arrow,.prev-arrow');var next=scope.querySelector('.mac-slide-arrow.icon-right-arrow,.next-arrow');if(!wrap)return;var max=Math.max(0,scroller.scrollWidth-scroller.clientWidth-2);var left=scroller.scrollLeft||0;wrap.classList.toggle('notscrollable',max<=2);if(prev)prev.classList.toggle('disable',left<=4||max<=2);if(next)next.classList.toggle('disable',left>=max||max<=2)})}ready(function(){updateMacArrows(document);document.querySelectorAll('.slide-work .mac-cards').forEach(function(scroller){scroller.addEventListener('scroll',function(){requestAnimationFrame(function(){updateMacArrows(scroller.closest('.slide-work')||document)})},{passive:true})});window.addEventListener('resize',function(){updateMacArrows(document)},{passive:true});setTimeout(function(){updateMacArrows(document)},600)})
function initQuickAddImageSliders(){
  if(!window.Splide) return false;
  document.querySelectorAll('.splide.image-slider').forEach(function(slider){
    var controller=slider.querySelector('.quick-add-slider__controller');
    if(controller) controller.style.display='block';
    if(slider.classList.contains('splide-initialized')||slider.classList.contains('is-initialized')) return;
    try{
      new Splide(slider,{type:'loop',perPage:1,pagination:true,arrows:true}).mount();
      slider.classList.add('splide-initialized');
    }catch(err){}
  });
  document.querySelectorAll('[id^="quick-add-slider"] .quick-add-slider__controller').forEach(function(ctrl){ctrl.style.display='block';ctrl.style.visibility='visible';ctrl.style.opacity='1'});
  return true;
}
function scheduleQuickAddInit(){
  if(initQuickAddImageSliders()) return;
  var tries=0;
  var timer=setInterval(function(){tries++; if(initQuickAddImageSliders()||tries>30) clearInterval(timer)},120);
}
function syncStickyReturnPanel(open){
  document.querySelectorAll('#sticky2 .return_inner').forEach(function(el){
    if(open){el.classList.remove('hidden'); void el.offsetHeight;}
    else{el.classList.add('hidden'); el.classList.remove('size_guige_open');}
  });
}
ready(function(){scheduleQuickAddInit();document.addEventListener('faetton:reinit',scheduleQuickAddInit);document.addEventListener('pjax:complete',scheduleQuickAddInit);window.addEventListener('load',scheduleQuickAddInit,{once:true});});
document.addEventListener('click',function(e){var btn=e.target.closest&&e.target.closest('.return_btn,.return_icon');if(!btn)return;syncStickyReturnPanel(true)},true);
document.addEventListener('click',function(e){var btn=e.target.closest&&e.target.closest('.return_close');if(!btn)return;syncStickyReturnPanel(false)},true);

function enforceQuickAddControls(){
  document.querySelectorAll('[id^="quick-add-slider"] .quick-add-slider__controller').forEach(function(ctrl){
    ctrl.style.display='block';
    ctrl.style.visibility='visible';
    ctrl.style.opacity='1';
    ctrl.querySelectorAll('.splide__arrow, .splide__pagination__page, svg, path').forEach(function(el){
      el.style.visibility='visible';
      el.style.opacity='1';
    });
  });
}
ready(function(){enforceQuickAddControls();document.addEventListener('faetton:reinit',function(){enforceQuickAddControls();});document.addEventListener('pjax:complete',function(){enforceQuickAddControls();});window.addEventListener('load',function(){enforceQuickAddControls();},{once:true});});



function initProductFancyboxBinding(){
  if(!(window.jQuery && window.jQuery.fn && window.jQuery.fn.fancybox)) return false;
  try{
    window.jQuery('[data-fancybox]').fancybox({ hash:false, image:{ preload:false } });
    try{document.dispatchEvent(new CustomEvent('faetton:fancybox-ready'));}catch(err){}
  }catch(err){}
  return true;
}
ready(function(){
  if(initProductFancyboxBinding()) return;
  var tries=0;
  var timer=setInterval(function(){
    tries++;
    if(initProductFancyboxBinding() || tries>40) clearInterval(timer);
  },100);
});

})();


/* FAETTON round5 final guards */
(function(){
  function ready(fn){ if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',fn,{once:true}); else fn(); }
  function hasFancybox(){ return !!(window.jQuery && window.jQuery.fn && window.jQuery.fn.fancybox); }
  function isProduct(){ return ((document.documentElement.getAttribute('data-template')||'').indexOf('product') !== -1); }
  function bindFancyboxNow(){
    if(!hasFancybox()) return false;
    try{
      window.jQuery('[data-fancybox]').fancybox({ hash:false, loop:true, infobar:false, buttons:['close'], image:{ preload:true } });
      try{ document.dispatchEvent(new CustomEvent('faetton:fancybox-ready')); }catch(e){}
    }catch(e){}
    return true;
  }
  ready(function(){
    bindFancyboxNow();
    var tries=0, timer=setInterval(function(){ tries++; if(bindFancyboxNow()||tries>20) clearInterval(timer); },80);
  });
  document.addEventListener('click',function(e){
    if(!isProduct()) return;
    var a=e.target&&e.target.closest?e.target.closest('#productSlider a[data-fancybox], .product__images a[data-fancybox], .product-template-image-div a[data-fancybox]'):null;
    if(!a) return;
    var idx=parseInt(a.getAttribute('data-faetton-media-index')||'',10);
    if(window.innerWidth<768 && !isNaN(idx) && typeof window.openMsLightbox==='function'){
      e.preventDefault(); e.stopPropagation(); if(e.stopImmediatePropagation)e.stopImmediatePropagation(); window.openMsLightbox(idx); return false;
    }
    if(!hasFancybox()){
      e.preventDefault(); e.stopPropagation(); if(e.stopImmediatePropagation)e.stopImmediatePropagation(); return false;
    }
  },true);
})();


/* FAETTON round6: final regression fixes */
(function(){
  'use strict';
  function ready(fn){ if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',fn,{once:true}); else fn(); }
  function isProduct(){ return (document.documentElement.getAttribute('data-template')||'').indexOf('product') !== -1; }
  function hasFancybox(){ return !!(window.jQuery && window.jQuery.fn && window.jQuery.fn.fancybox); }
  var lockedScrollY = 0;
  function lockPageScroll(){
    if(document.body.classList.contains('faetton-ms-lightbox-lock')) return;
    lockedScrollY = window.scrollY || window.pageYOffset || 0;
    document.documentElement.classList.add('faetton-ms-lightbox-lock');
    document.body.classList.add('faetton-ms-lightbox-lock','lightbox-active');
    document.body.style.top = '-' + lockedScrollY + 'px';
  }
  function unlockPageScroll(){
    var y = lockedScrollY || Math.abs(parseInt(document.body.style.top || '0',10)) || 0;
    document.documentElement.classList.remove('faetton-ms-lightbox-lock');
    document.body.classList.remove('faetton-ms-lightbox-lock','lightbox-active');
    document.body.style.top = '';
    document.body.style.position = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    try{ window.scrollTo(0,y); }catch(e){}
  }
  function patchMobileLightbox(){
    var modal = document.getElementById('ms-lightbox-modal');
    if(!modal) return;
    try { if (modal.parentElement !== document.body) document.body.appendChild(modal); } catch(err) {}
    if(modal.__faettonRound6Patched) return;
    modal.__faettonRound6Patched = true;
    modal.addEventListener('touchmove', function(e){
      var active = modal.querySelector('.ms-slides.active img');
      var scale = active ? (parseFloat(active.dataset.scale || '1') || 1) : 1;
      if(scale <= 1 && e.cancelable) e.preventDefault();
    }, { passive:false });
    var oldOpen = window.openMsLightbox;
    var oldClose = window.closeMsLightbox;
    window.openMsLightbox = function(index){
      try { if (modal.parentElement !== document.body) document.body.appendChild(modal); } catch(err) {}
      lockPageScroll();
      try{ if(typeof oldOpen === 'function') oldOpen(index); }
      catch(e){
        modal.style.display='flex';
        if(typeof window.showMsSlide === 'function') window.showMsSlide(index || 0);
      }
      modal.style.display='flex';
      modal.style.zIndex='2147483647';
      document.body.classList.add('lightbox-active');
    };
    window.closeMsLightbox = function(){
      try{ if(typeof oldClose === 'function') oldClose(); }
      catch(e){ modal.style.display='none'; }
      unlockPageScroll();
    };
  }
  function guardProductMediaLinks(){
    if(!isProduct()) return;
    document.querySelectorAll('#productSlider a[data-fancybox], .product__images a[data-fancybox], .product-template-image-div a[data-fancybox]').forEach(function(a){
      var href=a.getAttribute('href')||'';
      var src=a.getAttribute('data-src')||'';
      if(!src && href && href !== 'javascript:;' && href !== '#') a.setAttribute('data-src',href);
      a.setAttribute('href','javascript:;');
      a.setAttribute('data-no-instant','true');
    });
  }
  document.addEventListener('click',function(e){
    if(!isProduct()) return;
    var a=e.target&&e.target.closest?e.target.closest('#productSlider a, .product__images a, .product-template-image-div a'):null;
    if(!a) return;
    var isMedia = a.matches('[data-fancybox]') || a.hasAttribute('data-faetton-media-index') || /\.(jpg|jpeg|png|webp|gif|avif)(\?|$)/i.test((a.getAttribute('href')||'')+(a.getAttribute('data-src')||''));
    if(!isMedia) return;
    var idx=parseInt(a.getAttribute('data-faetton-media-index')||'',10);
    if(window.innerWidth<768 && !isNaN(idx) && typeof window.openMsLightbox==='function'){
      if(e.cancelable) e.preventDefault(); e.stopPropagation(); if(e.stopImmediatePropagation)e.stopImmediatePropagation();
      window.openMsLightbox(idx); return false;
    }
    if(a.getAttribute('href') !== 'javascript:;' && !hasFancybox()){
      if(e.cancelable) e.preventDefault(); e.stopPropagation(); if(e.stopImmediatePropagation)e.stopImmediatePropagation();
      return false;
    }
  }, true);
  function capQuickAddDots(root){
    (root||document).querySelectorAll('[id^="quick-add-slider"] .splide__pagination').forEach(function(pag){
      var pages=[].slice.call(pag.querySelectorAll('.splide__pagination__page'));
      if(!pages.length) return;
      var realActive=pages.findIndex(function(p){return p.classList.contains('is-active') || p.getAttribute('aria-selected')==='true';});
      if(realActive<0) realActive=0;
      var visualActive=Math.min(realActive,6);
      pages.forEach(function(btn,i){
        var li=btn.parentElement;
        var hide=i>6;
        btn.classList.toggle('faetton-dot-hidden', hide);
        if(li) li.classList.toggle('faetton-dot-hidden', hide);
        if(i<=6){
          btn.classList.toggle('is-active', i===visualActive);
          btn.setAttribute('aria-selected', i===visualActive ? 'true' : 'false');
        }
      });
      pag.classList.add('faetton-pagination-windowed');
      pag.style.transform='none';
    });
  }
  function normalizeUrl(u){
    if(!u) return '';
    var s=String(u).split('?')[0].toLowerCase();
    s=s.replace(/_(\d+x\d+|\d+x|x\d+|pico|icon|thumb|small|compact|medium|large|grande|master)(?=\.)/g,'');
    return s;
  }
  function findVariantByOptions(form, prod){
    if(!prod || !prod.variants) return null;
    var selected=[];
    form.querySelectorAll('.optionselect').forEach(function(sel){ if(sel.value) selected.push(sel.value); });
    form.querySelectorAll('.radio-option input[type="radio"]:checked').forEach(function(inp){ if(inp.value) selected.push(inp.value); });
    selected=selected.filter(Boolean);
    if(!selected.length) return null;
    return prod.variants.find(function(v){
      var opts=[v.option1,v.option2,v.option3].filter(Boolean).map(String);
      return selected.every(function(val){ return opts.indexOf(String(val))!==-1; });
    }) || null;
  }
  function goQuickAddToImage(root, imageUrl){
    if(!root || !imageUrl) return;
    var slider=root.querySelector('[id^="quick-add-slider"], .image-slider');
    if(!slider) return;
    var list=slider.querySelector('.splide__list') || slider.querySelector('.slider-container') || slider.querySelector('.splide__track');
    var slides=[].slice.call(slider.querySelectorAll('.splide__slide, .slider-item'));
    var target=normalizeUrl(imageUrl), found=-1;
    slides.forEach(function(slide,i){
      if(found!==-1) return;
      var img=slide.querySelector('img'); if(!img) return;
      var src=normalizeUrl(img.currentSrc || img.src || img.getAttribute('src') || img.getAttribute('data-src'));
      if(src && (src.indexOf(target)!==-1 || target.indexOf(src)!==-1 || src.split('/').pop()===target.split('/').pop())) found=i;
    });
    if(found<0) return;
    if(list){
      var left=slides[found].offsetLeft || 0;
      try{ list.scrollTo({left:left,behavior:'smooth'}); }catch(e){ list.scrollLeft=left; }
    }
    setTimeout(function(){
      var pages=[].slice.call(slider.querySelectorAll('.splide__pagination__page,.dots-inner .dot'));
      pages.forEach(function(p,i){ p.classList.toggle('is-active',i===found); p.classList.toggle('active',i===found); });
      capQuickAddDots(slider);
    },120);
  }
  function syncFlyoutVariantImage(e){
    var target=e.target;
    if(!target || !target.closest) return;
    var root=target.closest('.prod_flyout-radous');
    if(!root) return;
    var imageUrl=null;
    if(target.matches('input[type="radio"]')) imageUrl=target.getAttribute('data-variantid') || (root.querySelector('label[for="'+target.id+'"]')||{}).dataset?.img;
    if(!imageUrl && target.matches('label')){
      var inp=root.querySelector('#'+CSS.escape(target.getAttribute('for')||''));
      imageUrl=(inp&&inp.getAttribute('data-variantid')) || target.getAttribute('data-img');
    }
    if(!imageUrl){
      var form=root.querySelector('[data-prod]');
      var prod=null;
      try{ prod=JSON.parse((form&&form.getAttribute('data-prod'))||'null'); }catch(err){}
      var v=form?findVariantByOptions(form,prod):null;
      if(v && v.featured_image) imageUrl=(v.featured_image.src || v.featured_image.url || v.featured_image);
    }
    if(imageUrl) setTimeout(function(){goQuickAddToImage(root,imageUrl);},60);
  }
  ready(function(){
    
    patchMobileLightbox();
    guardProductMediaLinks();
    capQuickAddDots(document);
    
    document.addEventListener('click',syncFlyoutVariantImage,true);
    document.addEventListener('change',syncFlyoutVariantImage,true);
    var mo=new MutationObserver(function(){ patchMobileLightbox(); guardProductMediaLinks(); capQuickAddDots(document); });
    mo.observe(document.documentElement,{childList:true,subtree:true});
  });
  document.addEventListener('faetton:reinit',function(){patchMobileLightbox();guardProductMediaLinks();capQuickAddDots(document);});
  document.addEventListener('pjax:complete',function(){patchMobileLightbox();guardProductMediaLinks();capQuickAddDots(document);});
})();


/* FAETTON round6: header + sticky transplanted from rebuild-original-safe */
(function(){
  'use strict';
  var doc = document;
  var html = doc.documentElement;

  function ready(fn){
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  }

  function isMobile(){
    return window.matchMedia ? window.matchMedia('(max-width: 1156px)').matches : (window.innerWidth <= 1156);
  }

  function releaseHeaderLoading(){
    html.classList.remove('js-loading');
    html.classList.add('page-ready');
  }

  ready(releaseHeaderLoading);
  window.addEventListener('pageshow', releaseHeaderLoading);

  function findMainATC(){
    var selectors = [
      '.main-atc-form button[name="add"]',
      '.main-atc-form [name="add"]',
      '.product_form button[name="add"]',
      '.product-form button[name="add"]',
      '.purchase-details button[name="add"]',
      'button.ajax-submit.action_button.add_to_cart:not(#sticky .ajax-submit):not(#sticky2 .ajax-submit)',
      'a.ajax-submit.action_button.add_to_cart:not(#sticky .ajax-submit):not(#sticky2 .ajax-submit)',
      'button[name="add"]'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var nodes = Array.prototype.slice.call(doc.querySelectorAll(selectors[i]));
      var found = nodes.find(function(el){
        return el &&
          !el.closest('#sticky') &&
          !el.closest('#sticky2') &&
          !el.closest('.product-popup-container2') &&
          !el.closest('.prod_flyout-radous') &&
          el.offsetParent !== null;
      });
      if (found) return found;
    }
    return null;
  }

  function getStickies(){
    return Array.prototype.slice.call(doc.querySelectorAll('#sticky2, #sticky'));
  }

  function setStickyVisible(sticky, visible){
    if (!sticky) return;
    sticky.classList.toggle('show', visible);
    if (sticky.id === 'sticky2') sticky.classList.toggle('faetton-mobile-sticky-visible', visible);
    sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
  }

  function updateStickyVisibility(){
    var stickies = getStickies();
    if (!stickies.length) return;

    if (!isMobile()) {
      stickies.forEach(function(sticky){
        if (sticky.id === 'sticky2') sticky.classList.remove('faetton-mobile-sticky-visible');
        sticky.removeAttribute('aria-hidden');
        sticky.style.removeProperty('display');
        sticky.style.removeProperty('visibility');
        sticky.style.removeProperty('opacity');
      });
      return;
    }

    var btn = findMainATC();

    /* Safety fallback: if this template has no detectable main ATC, do not hide the sticky forever. */
    if (!btn) {
      stickies.forEach(function(sticky){ setStickyVisible(sticky, true); });
      return;
    }

    var rect = btn.getBoundingClientRect();
    var passedMainButton = rect.bottom <= 0;

    stickies.forEach(function(sticky){
      setStickyVisible(sticky, passedMainButton);
    });
  }

  var raf = null;
  function scheduleStickyUpdate(){
    if (raf) return;
    raf = window.requestAnimationFrame(function(){
      raf = null;
      updateStickyVisibility();
    });
  }

  ready(function(){
    releaseHeaderLoading();
    updateStickyVisibility();
    setTimeout(updateStickyVisibility, 120);
    setTimeout(updateStickyVisibility, 600);
    setTimeout(updateStickyVisibility, 1400);
  });

  window.addEventListener('scroll', scheduleStickyUpdate, { passive: true });
  window.addEventListener('resize', scheduleStickyUpdate, { passive: true });
  window.addEventListener('load', function(){
    releaseHeaderLoading();
    updateStickyVisibility();
  });

  doc.addEventListener('shopify:section:load', scheduleStickyUpdate);
  doc.addEventListener('faetton:reinit', scheduleStickyUpdate);
  doc.addEventListener('pjax:complete', scheduleStickyUpdate);

  try {
    new MutationObserver(scheduleStickyUpdate).observe(doc.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'aria-hidden']
    });
  } catch (err) {}
})();



/* FAETTON round11: quick-add arrows - real movement fallback only for quick-add sliders */
(function(){
  'use strict';

  function closest(el, sel){ return el && el.closest ? el.closest(sel) : null; }
  function qs(root, sel){ return root ? root.querySelector(sel) : null; }
  function qsa(root, sel){ return root ? Array.prototype.slice.call(root.querySelectorAll(sel)) : []; }

  function getRootFromButton(btn){
    return closest(btn, '[id^="quick-add-slider"]');
  }

  function getTrack(root){
    return qs(root, '.splide__track') || root;
  }

  function getList(root){
    return qs(root, '.splide__list') || qs(root, '.slider-container') || qs(root, '.splide__track');
  }

  function getSlides(root){
    var slides = qsa(root, '.splide__slide');
    if (!slides.length) slides = qsa(root, '.slider-item');
    return slides;
  }

  function getDots(root){
    var dots = qsa(root, '.splide__pagination__page');
    if (!dots.length) dots = qsa(root, '.dots-inner .dot');
    return dots;
  }

  function currentIndex(root, list, slides){
    var stored = parseInt(root.getAttribute('data-faetton-arrow-index') || '', 10);
    if (!isNaN(stored)) return Math.max(0, Math.min(stored, Math.max(0, slides.length - 1)));

    var dots = getDots(root);
    var active = dots.findIndex(function(dot){
      return dot.classList.contains('is-active') || dot.classList.contains('active') || dot.getAttribute('aria-selected') === 'true';
    });
    if (active >= 0) return Math.max(0, Math.min(active, Math.max(0, slides.length - 1)));

    var left = list && list.scrollLeft ? list.scrollLeft : 0;
    if (left && slides.length) {
      var best = 0, dist = Infinity;
      slides.forEach(function(slide, i){
        var d = Math.abs((slide.offsetLeft || 0) - left);
        if (d < dist) { dist = d; best = i; }
      });
      return best;
    }

    return 0;
  }

  function updateDots(root, index){
    var dots = getDots(root);
    if (!dots.length) return;
    var maxVisible = 7;
    var visualActive = Math.min(index, maxVisible - 1);
    dots.forEach(function(dot, i){
      var hidden = i >= maxVisible;
      var active = i === visualActive;
      dot.classList.toggle('is-active', active);
      dot.classList.toggle('active', active);
      dot.classList.toggle('faetton-dot-hidden', hidden);
      if (dot.parentElement) dot.parentElement.classList.toggle('faetton-dot-hidden', hidden);
      dot.setAttribute('aria-selected', active ? 'true' : 'false');
    });
  }

  function hardMove(root, dir){
    var list = getList(root);
    var track = getTrack(root);
    var slides = getSlides(root);
    if (!root || !list || slides.length < 2) return;

    var current = currentIndex(root, list, slides);
    var next = dir === 'prev' ? current - 1 : current + 1;
    if (next < 0) next = slides.length - 1;
    if (next >= slides.length) next = 0;

    root.setAttribute('data-faetton-arrow-index', String(next));

    // Native scroll sliders used by upsell/flyout popups.
    if (list.classList.contains('slider-container')) {
      var targetLeft = slides[next].offsetLeft || 0;
      try { list.scrollTo({ left: targetLeft, behavior: 'smooth' }); }
      catch (err) { list.scrollLeft = targetLeft; }
      updateDots(root, next);
      return;
    }

    // Splide-like quick-add markup. Force one slide per viewport and move by transform.
    var width = (track && track.clientWidth) || root.clientWidth || (slides[0] && slides[0].getBoundingClientRect().width) || 1;
    slides.forEach(function(slide){
      slide.style.flex = '0 0 100%';
      slide.style.maxWidth = '100%';
    });
    if (list.style) {
      list.style.display = 'flex';
      list.style.overflow = 'visible';
      list.style.transition = 'transform .28s ease';
      list.style.willChange = 'transform';
      list.style.transform = 'translate3d(' + (-(width * next)) + 'px, 0, 0)';
      try { list.scrollLeft = 0; } catch (err) {}
    }
    updateDots(root, next);
  }

  document.addEventListener('click', function(e){
    var btn = closest(e.target, '[id^="quick-add-slider"] .splide__arrows .splide__arrow, [id^="quick-add-slider"] .slider-nav .arrow');
    if (!btn) return;
    var root = getRootFromButton(btn);
    if (!root) return;

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    var dir = (btn.classList.contains('splide__arrow--prev') || btn.classList.contains('prev')) ? 'prev' : 'next';
    hardMove(root, dir);
  }, true);
})();
